"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.69 3.213a.73.73 0 0 1 1.03 0l6.477 6.477a.73.73 0 0 1 0 1.03l-6.477 6.477a.73.73 0 0 1-1.03 0L3.213 10.72a.73.73 0 0 1 0-1.03zm-4.932 6.992 5.447 5.447 5.447-5.447-5.447-5.447z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.126 8.749a.377.377 0 1 0 0 .754.377.377 0 0 0 0-.754m0 1.456a1.08 1.08 0 1 0 0-2.159 1.08 1.08 0 0 0 0 2.16",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.293 4.293a.73.73 0 0 1 1.03 0L9.64 8.61a.728.728 0 1 1-1.03 1.03L4.293 5.323a.73.73 0 0 1 0-1.03m13.469 15.25c1.172 0 1.781-.793 1.781-1.377 0-.262-.187-.811-.683-1.596a15 15 0 0 0-1.098-1.49c-.367.443-.765.962-1.099 1.49-.496.785-.683 1.334-.683 1.596 0 .584.609 1.377 1.782 1.377m0 1.457C19.55 21 21 19.731 21 18.166c0-1.413-1.58-3.419-2.532-4.5a.933.933 0 0 0-1.413 0c-.953 1.081-2.532 3.087-2.532 4.5 0 1.565 1.45 2.834 3.239 2.834",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=StyleIcon24.js.map